import React from 'react';

import { useTranslation } from 'react-i18next';

import ReactSelect from 'react-select';
import { GroupedOptionsType, OptionsType } from 'react-select/src/types';

import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';

export interface OptionType {
  label: string;
  value: string | number;
}

class Select extends ReactSelect<OptionType> {}

interface OwnProps {
  className?: string;
  disabled?: boolean;
  id: string;
  label: string;
  loading?: boolean;
  name: string;
  options: GroupedOptionsType<OptionType> | OptionsType<OptionType>;
  placeholder?: string;
  srOnlyLabel?: boolean;
  value: string | number;
  onChange: (newValue: string | number) => void;
}

type Props = Readonly<OwnProps>;

const FilterInput: React.FC<Props> = ({
  className,
  loading,
  disabled,
  id,
  label,
  name,
  options,
  placeholder,
  srOnlyLabel,
  value,
  onChange,
}) => {
  const { t } = useTranslation();

  const valueType = value === '' ? '' : Object.values(options).find((o) => o.value === value);
  return (
    <FormGroup tag="fieldset" disabled={disabled} className={className}>
      <Label for={id} className={srOnlyLabel ? 'sr-only' : undefined}>
        {label}
      </Label>
      <Select
        noOptionsMessage={() => t(`MASONRY.SEARCH.FILTER_NO_MATCH`)}
        inputId={id}
        isLoading={loading}
        isDisabled={disabled}
        classNamePrefix="react-select"
        name={name}
        value={valueType}
        placeholder={placeholder || t(`MASONRY.SEARCH.ALL`)}
        onChange={(optionType: OptionType) => onChange(optionType ? optionType.value : '')}
        options={options}
        isClearable
      />
    </FormGroup>
  );
};

export default React.memo(FilterInput);
